var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBeenhere = function SvgBeenhere(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.942 5.223 16.86a1.7 1.7 0 0 1-.53-.633 1.8 1.8 0 0 1-.193-.813V3.866q0-.759.525-1.283.525-.525 1.283-.525h11.384q.758 0 1.283.525t.525 1.283v11.548q0 .426-.193.813a1.7 1.7 0 0 1-.53.633zm0-1.884 5.875-4.404a.4.4 0 0 0 .091-.11.3.3 0 0 0 .034-.14V3.866a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H6.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v11.538q0 .077.034.14a.4.4 0 0 0 .091.11zm-1.05-5.846 5.304-5.304L15.2 7.823l-4.25 4.25-2.12-2.119-1.084 1.054z"
  })));
};
export default SvgBeenhere;